import React, { useState, useEffect, useContext } from "react";
import Tooltip from "react-tooltip-lite";
import parse from "react-html-parser";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import "./Modal.css";
import { Row, Col, Container, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { ThemeContext } from "../../container/mppmodal/MppInfo";
import toolTipIcon from "../../assets/images/toolTipIcon.svg";
import plShopCart from "../../assets/images/PL-ShopCart.svg";
import plPie from "../../assets/images/PL-Pie.svg";
import plShopBag from "../../assets/images/PL-ShopBag.svg";
import synchronyIcon from "../../assets/images/Synchrony_Logo_RGB_Pos.svg";

var totalOffers = 0;

const MppModalInfo = (props) => {
  const {
    activeIndex,
    setActiveIndex,
    maxPurchase,
    minPurchase,
    flowType,
    isCheckoutLearnClicked,
    setPayIn4Info,
  } = props;

  const {
    url,
    isToolTip,
    toolTipContent,
    offerRangeLanguage,
    cardName,
    pie1img,
    pie2img,
    pie3img,
    pie4img,
    triangleExclaminationimg,
    learchHowIconDownimg,
    learchHowIconUpimg,
    mppFromEmail,
    additionalInfo,
    featureOfferFootermpp,
    applyDisabled,
    isSetPayIn4Alone,
    orgPlatForm,
    noOfRevolvingPreferred,
    mppConfig,
    openSetPayIn4
  } = useContext(ThemeContext);


  const [btnShow, setBtnShow] = useState(true);
  const [isWPDAAtFirst, setIsWPDAAtFirst] = useState(props.isWPDAAtFirst);
  const [selectedIndex, setSelectedIndex] = useState(activeIndex);
  const [toggleBtn, setToggleBtn] = useState(false);
  const WPDAIndex = props.index;
  
  const { quickScreenApproved } = mppConfig || {};
  const icons = [pie1img, pie2img, pie3img, pie4img];

  const getTitleWithoutTotalPayment = (title) => {
    if (!title) return title;
    const totalPaymentIndex = title.indexOf("<br/> Total Payments:");
    if (totalPaymentIndex > -1) {
      return title.substring(0, totalPaymentIndex).trim();
    }
    return title;
  };

  useEffect(() => {
    totalOffers++;
  }, []);
  function CustomToggle({ children, eventKey }) {
    return (
      <div className="text-center">
        <button
          tabIndex="0"
          type="button"
          className="btn viewExtraBtn viewLess"
          onClick={() => {
            hideOffers(eventKey);
          }}
        >
          {children}{" "}
        </button>
      </div>
    );
  }
  function hideOffers(eventKey) {
    window.setTimeout(() => {
      customHideOffer(eventKey);
    }, 400);
  }
  function showOffers(eventKey) {
    setIsWPDAAtFirst(false);
    var learnHowSpan = document.getElementById("span" + eventKey);
    if (
      document
        .getElementById("removeshow" + eventKey)
        .classList.contains("show")
    ) {
      learnHowSpan.style.visibility = "hidden";
    } else {
      learnHowSpan.style.visibility = "visible";
    }

    if (
      document
        .getElementById("btn" + eventKey)
        .classList.contains("learnBtntoggle") &&
      document
        .getElementById("removeshow" + eventKey)
        .classList.contains("show")
    ) {
      window.setTimeout(() => {
        customHideOffer(eventKey);
      }, 400);
    } else if (
      document
        .getElementById("btn" + eventKey)
        .classList.contains("learnBtntoggle")
    ) {
      window.setTimeout(() => {
        customShowOffer(eventKey);
      }, 400);
    } else if (
      document.getElementById("btn" + eventKey).classList.contains("caret2")
    ) {
      window.setTimeout(() => {
        customHideOffer(eventKey);
      }, 400);
    }

    for (let index = 0; index < totalOffers; index++) {
      if (index !== eventKey) {
        window.setTimeout(() => {
          customHideOffer(index);
        }, 400);
      }
    }
  }

  function customShowOffer(index) {
    var learnHowSpan = document.getElementById("span" + index);
    document.getElementById("btn" + index).classList.remove("learnBtntoggle");
    document.getElementById("btn" + index).classList.add("caret2");
    document.getElementById("img" + index).src = learchHowIconUpimg;
    document.getElementById("img" + index).alt = "Learn How Up Icon";
    document.getElementById("btn" + index).setAttribute("aria-expanded", false);
    document.getElementById("removeshow" + index).classList.add("show");
    learnHowSpan.style.visibility = "hidden";
  }
  function customHideOffer(index) {
    if (document.getElementById("span" + index) != null) {
      var learnHowSpan = document.getElementById("span" + index);
    }
    if (document.getElementById("removeshow" + index) != null) {
      document.getElementById("removeshow" + index).classList.remove("show");
    }
    if (document.getElementById("removeshow" + index) != null) {
      document.getElementById("btn" + index).classList.remove("caret2");
      document.getElementById("btn" + index).classList.add("learnBtntoggle");
      document.getElementById("img" + index).src = learchHowIconDownimg;
      document.getElementById("img" + index).alt = "Learn How Down Icon";
      document.getElementById("btn" + index).removeAttribute("aria-expanded");
    }
    if (learnHowSpan != null) {
      learnHowSpan.style.visibility = "visible";
    }
  }
  function removeShow(index) {
    if (
      document.getElementById("removeshow" + index) &&
      document.getElementById("removeshow" + index).classList
    ) {
      document.getElementById("removeshow" + index).classList.remove("show");
    }
  }
  function firstRow() {
    return (
      <Container className="ml-0 p-0 onlyMediaScreen" fluid={true}>
        {props.displayLabel && offerLable()}
        <Card
          className="borderNoneoffer"
          style={{
            borderColor:
              props.prefferedOffer == "YES"
                ? props.brandings.mppPrimaryColors
                : "#f0f1f0",
          }}
        >
          <Card.Header className="borderNone">
            {flowType === "PDP" && props.offerType === "WPDI" && props.brandings?.mpp_variant && !isCheckoutLearnClicked && props.prefferedOffer == "YES" && (
              <Row>
                <Col xs="12" className="verticalCenter ifmediaScreen variantWpdiHeadingCol">
                  <p role="heading" aria-level="3"
                    className="mb-0 testClass marginLeft variantWpdiHeadingText"
                    id={"testActive" + props.accordianIndex}
                    style={{
                      fontFamily: props.brandings?.mpp_variant?.fontFamily,
                      fontWeight: props.brandings?.mpp_variant?.fontWeight,
                      fontSize: props.brandings?.mpp_variant?.fontSize,
                      lineHeight: props.brandings?.mpp_variant?.lineHeight,
                    }}
                  >
                    {parse(props.offerLoyaltyPromoDisclosure || props.offerBannerTitle)}
                  </p>
                </Col>
              </Row>
            )}
            <Row className="textAlignInt">
              <Col xs="11" className="verticalCenter ifmediaScreen ">
                {
                  flowType === "PDP" && props.offerType === "WPDI" && props.brandings?.mpp_variant && !isCheckoutLearnClicked && props.prefferedOffer == "YES" ? (
                    <>
                      <span className="ifTotalPayment mb-0 subTitleInfo marginLeft">
                        {" "}
                        {props.offerBannerSubTitle}
                      </span>
                      <span className="ifTotalPayment mb-0 subTitleInfo marginLeft wpdiTitleSubtext"
                      style={{
                        fontFamily: props.brandings?.mpp_variant?.fontFamily,
                        fontWeight: props.brandings?.mpp_variant?.fontWeight,
                        "--wpdi-title-fs": props.brandings?.mpp_variant?.fontSize,
                        lineHeight: props.brandings?.mpp_variant?.lineHeight,
                      }}>
                        {parse(props.offerLoyaltyPromoDisclosure ? props.offerBannerTitle : "")}
                      </span>
                      <span className="ifTotalPayment mb-0 subTitleInfo marginLeft">
                        {" "}
                        {parse(props.ofpTitle)}
                      </span>
                      {props.limitedTimeOfferDateFormatVariant && (
                        <span className="ifTotalPayment mb-0 subTitleInfo marginLeft">
                          {" "}
                          {props.limitedTimeOfferDateFormatVariant}
                        </span>
                      )}
                      {((props.offerType == "PPPP" &&
                        props.discountEligible == "true") ||
                        props.offerType !== "PPPP") && (
                          <span className="ifTotalPayment mb-0 subTitleInfo marginLeft">
                            {props.offerBannerDisclaimer}
                          </span>
                        )}
                    </>
                  ) : (
                  <>
                    <p role="heading" aria-level="3"
                      className="mb-0 testClass marginLeft"
                      id={"testActive" + props.accordianIndex}
                    >
                      <b>
                        {parse(props.offerLoyaltyPromoDisclosure || (props.offerType === "WPDI" ? getTitleWithoutTotalPayment(props.offerBannerTitle) : props.offerBannerTitle))}
                      </b>
                    </p>
                    {props.offerType == "WPDI" ? (
                      <span className="ifTotalPayment mb-0 subTitleInfo marginLeft">
                        {" "}
                        {props.offerBannerSubTitle}
                      </span>
                    ) : (
                      <p role="heading" aria-level="3"
                        className="mb-0 testClass marginLeft"
                        id={"testActive" + props.accordianIndex}
                      >
                        {parse(props.offerBannerSubTitle)}
                      </p>
                    )}
                    <span className="ifTotalPayment mb-0 subTitleInfo marginLeft">
                      {parse(props.offerLoyaltyPromoDisclosure ? (props.offerType === "WPDI" ? getTitleWithoutTotalPayment(props.offerBannerTitle) : props.offerBannerTitle) : "")}
                    </span>
                    <span className="ifTotalPayment mb-0 subTitleInfo marginLeft">
                      {" "}
                      {parse(props.ofpTitle)}
                    </span>
                    {props.limitedTimeOfferDateFormat && (
                      <span className="ifTotalPayment mb-0 subTitleInfo marginLeft">
                        {" "}
                        {props.limitedTimeOfferDateFormat}
                      </span>
                    )}
                    {((props.offerType == "PPPP" &&
                      props.discountEligible == "true") ||
                      props.offerType !== "PPPP") && (
                        <span className="ifTotalPayment mb-0 subTitleInfo marginLeft">
                          {props.offerBannerDisclaimer}
                        </span>
                      )}
                  </>
                  )
                }
              </Col>
              {(
                <>
                  <Col xs="1" className="learmoreBtn onlyMedialearn">
                    <Accordion.Item
                      as={Card.Header}
                      eventKey={`${WPDAIndex}`}
                      style={{ display: "inline-grid" }}
                      onClick={() => {
                        setToggleBtn(!toggleBtn);
                        if (props.accordianIndex) {
                          setTimeout(function () {
                            var elem = document.getElementById(
                              "testActive" + (props.accordianIndex - 1)
                            );
                            elem.scrollIntoView();

                          }, 300);
                        }
                      }}
                    >
                      {props.toggleProp ===
                        props.offerBannerTitle + props.index ? (
                        toggleBtn ? (
                          <button
                            id={`btn${WPDAIndex}`}
                            className="btn learBtn caret2 learnHow"
                            aria-expanded="false"
                            tabIndex="0"
                            onClick={(event) => {
                              analyticsChanges();
                              showOffers(WPDAIndex);
                              setActiveIndex(WPDAIndex);
                              if (
                                activeIndex !== "" ||
                                (isWPDAAtFirst && WPDAIndex == 0)
                              ) {
                                if (
                                  document.getElementById(
                                    "removeshow" + activeIndex
                                  ) &&
                                  document.getElementById(
                                    "removeshow" + activeIndex
                                  ).classList
                                ) {
                                  document
                                    .getElementById("removeshow" + activeIndex)
                                    .classList.remove("show");
                                }
                              } else {
                                event.stopPropagation();
                                event.preventDefault();
                              }
                            }}
                            style={{ color: "black" }}
                          >
                            {" "}
                            <img
                              id={`img${WPDAIndex}`}
                              src={learchHowIconDownimg}
                              alt="Learn How Down Icon"
                            />{" "}
                          </button>
                        ) : (
                          <button
                            id={`btn${WPDAIndex}`}
                            className="btn learBtn learnBtntoggle learnHow"
                            tabIndex="0"
                            style={{ color: "black" }}
                            onClick={(event) => {
                              analyticsChanges();
                              showOffers(WPDAIndex);
                              setActiveIndex(WPDAIndex);
                              if (
                                activeIndex !== "" ||
                                (isWPDAAtFirst && WPDAIndex == 0)
                              ) {
                                if (
                                  document.getElementById(
                                    "removeshow" + activeIndex
                                  ) &&
                                  document.getElementById(
                                    "removeshow" + activeIndex
                                  ).classList
                                ) {
                                  document
                                    .getElementById("removeshow" + activeIndex)
                                    .classList.remove("show");
                                }
                              } else {
                                event.stopPropagation();
                                event.preventDefault();
                              }
                            }}
                          >
                            <img
                              id={`img${WPDAIndex}`}
                              src={learchHowIconDownimg}
                              alt="Learn How Down Icon"
                            />{" "}
                          </button>
                        )
                      ) : (
                        <button
                          id={`btn${WPDAIndex}`}
                          className="btn learBtn learnBtntoggle learnHow"
                          tabIndex="0"
                          style={{ color: "black" }}
                          onClick={(event) => {
                            analyticsChanges();
                            showOffers(WPDAIndex);
                            setActiveIndex(WPDAIndex);
                            if (
                              activeIndex !== "" ||
                              (isWPDAAtFirst && WPDAIndex == 0)
                            ) {
                              if (
                                document.getElementById(
                                  "removeshow" + activeIndex
                                ) &&
                                document.getElementById(
                                  "removeshow" + activeIndex
                                ).classList
                              ) {
                                document
                                  .getElementById("removeshow" + activeIndex)
                                  .classList.remove("show");
                              }
                            } else {
                              event.stopPropagation();
                              event.preventDefault();
                            }
                          }}
                        >
                          <img
                            id={`img${WPDAIndex}`}
                            src={learchHowIconDownimg}
                            alt="Learn How Down Icon"
                          />{" "}
                        </button>
                      )}
                      <span
                        id={`span${WPDAIndex}`}
                        style={{
                          fontSize: "9px",
                          textAlign: "center",
                          width: "27px",
                          color: "#000",
                          fontWeight: mppFromEmail ? "800" : "600",
                          lineHeight: "10px",
                        }}
                      >
                        Learn How
                      </span>
                    </Accordion.Item>
                  </Col>
                </>
              )}
            </Row>
          </Card.Header>
          <Accordion.Collapse
            eventKey={`${WPDAIndex}`}
            id={`removeshow${WPDAIndex}`}
          >
            <Card.Body
              id={props.offerBannerTitle + props.index}
              name={props.offerBannerTitle + props.index}
            >
              <div className={`expansionDiv${WPDAIndex}`} id="expansionDivTest">
                {isWPDAAtFirst &&
                  props.index === 0 &&
                  props.offerType === "WPDI" ? (
                  <>
                    {removeShow(WPDAIndex)}
                    {!btnShow && <></>}
                  </>
                ) : (
                  <>
                    <div>
                      {props.offerType == "PPPP" &&
                        props.discountEligible == "false" && (
                          <div id="expansionDivCoreNoPromo">
                            {parse(props.offerBannerDisclaimer)}
                          </div>
                        )}
                      {
                        ["EPNIPF", "EPNIIOPF","EPNI150PROMOFEE"].includes(props.offerType) && (
                          <div className="expansionInsideDiv" style={{ paddingBottom: "12px" }}>
                            <b>{parse(props.ofpLanguage)}</b>
                          </div>
                        )
                      }
                      <div>
                        {" "}
                        {parse(props.monthlyPaymentDisclosure)}{" "}
                      </div>
                      <div>
                        {parse(
                          props.monthlyPaymentDisclosureLanguage != ""
                            ? "<br/>" + props.monthlyPaymentDisclosureLanguage
                            : ""
                        )}
                      </div>
                      <div>
                        {props.discountEligible == "true" ? (
                          <>{parse(props.offerDisclosure)} </>
                        ) : (
                          <>
                            <br></br>
                            {parse(props.offerDisclosure)}{" "}
                          </>
                        )}
                      </div>
                      <br />
                      <div>
                        {parse(props.offerDisclosureLanguage)}{" "}
                      </div>
                    </div>

                    <CustomToggle
                      tabIndex="0"
                      type="button"
                      className="testFocus"
                      eventKey={`${WPDAIndex}`}
                    >
                      <span
                        aria-labelledby="view less"
                        style={{ color: props.brandings.mppPrimaryColors }}
                      >
                        View Less
                      </span>
                    </CustomToggle>
                  </>
                )}
              </div>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
        {props.prefferedOffer == "YES" && applyDisabled !== "Y" && (
          <>
            {mppFromEmail ? (
              <Row className="emailExistingCardHolder">
                <Col xs="12" className="text-center" style={{ display: "flex", alignItems: "center" }}>
                  <div className="emailExistingCard-holder">
                    <img
                      src={triangleExclaminationimg}
                      alt="Important Info"
                    />
                  </div>
                  <span style={{ fontSize: "14px", textAlign: "left", color: "#6E6E6E" }}>
                    {featureOfferFootermpp}
                  </span>
                </Col>
              </Row>
            ) : (!quickScreenApproved &&
              <Row>
                <Col xs="12">
                  {/* need to display based on QS condition  */}
                  {
                    <div className="existingCard-holder d-flex">
                      <img
                        src={triangleExclaminationimg}
                        alt="Important Info"
                      />
                      <span style={{ color: "#656565" }}>
                        {featureOfferFootermpp}
                      </span>
                    </div>
                  }
                </Col>
              </Row>
            )
            }
          </>
        )}
      </Container>
    );
  }
  const offerLable = () => {
    return (
      <>
        {props.accordianIndex == 0 && props.prefferedOffer == "YES" && (
          <Row xs="12" className="cardText featured-card-text" >
            <Col xs={12} md={12} sm={12}>
              <p role="heading" aria-level="2">
                <b style={{ color: mppFromEmail ? "#000000" : "#333" }}>Featured Offers</b>
              </p>
            </Col>
          </Row>
        )}
        {props.accordianIndex == 0 && props.prefferedOffer == "NO" && (
          <Row xs="12" className="cardText">
            <Col xs={12} md={12} sm={12}>
              {props.index != 0 && <hr className="textag"></hr>}
              <p role="heading" aria-level="2">
                <b style={{ color: mppFromEmail ? "#000000" : "#333" }}>Other Available Offers</b>
              </p>
            </Col>
          </Row>
        )}

        {props.offerType === "SetPAY" && (
          <Row xs="12" className={
            (props.prefferedOffer == "YES" && noOfRevolvingPreferred)
              ? "creditInfotext cardText paylaterCreditText"
              : "creditInfotext cardText"
          } ml="0">
            <Col xs={6} md={6} sm={6} className="lableType">
              <p>Pay Monthly Loan</p>
            </Col>
            <Col xs={6} md={6} sm={6} className="text-end paddingRight">
              <img
                src={props.brandings.setPaycreditCardImage}
                alt="Pay Later"
                title="Pay Later"
                style={{ width: "80px", height: "18px" }}
              />
            </Col>
          </Row>
        )}

        {["WPDI", "EPNI", "FPRR", "EPNU", "EPNIIO", "PPPP", "EPNIIOPF", "EPNIPF","EPNI150PROMOFEE","FPWI150PROMOFEE"].includes(
          props.offerType
        ) && (
            <Row xs="12" className="creditInfotext cardText">
              <Col xs={9} md={9} sm={9} className="lableType">
                <div className="creditTextDiv">
                  <p className="creditTextPara">{cardName} </p>
                  {isToolTip === "Y" && toolTipContent ? (
                    <Tooltip
                      className="syf_tooltipinfo"
                      content={toolTipContent}
                      direction="up"
                      eventOn="onFocus"
                      eventOff="onKeyDown"
                    >
                      <img
                        src={toolTipIcon}
                        className="toolTipImg"
                        alt="Tool Tip"
                      ></img>
                    </Tooltip>
                  ) : null}
                </div>
              </Col>
              <Col xs={3} md={3} sm={3} className="text-end paddingRight">
                <img
                  src={props.brandings.creditCardImage}
                  alt=""
                />
              </Col>
            </Row>
          )}
        {props.offerType === "SetPAYIn4" && (
          <Row xs="12" className={
            (props.prefferedOffer == "YES" && noOfRevolvingPreferred && flowType !== "CHECKOUT")
              ? "creditInfotext cardText paylaterCreditText"
              : "creditInfotext cardText"
          } ml="0">
            <Col xs={8} md={8} sm={8} className="lableType">
              <p >Pay in 4 Loan</p>
            </Col>
            <Col xs={4} md={4} sm={4} className="text-end paddingRight width=50">
              <img style={{ width: "80px", height: "18px" }}
                src={props.brandings.synchronySetPayIn4Image}
                alt="Pay Later "
                title="Pay Later"
              />
            </Col>
          </Row>
        )}
      </>
    );
  };

  function firstRow2() {
    return (
      <Container className="ml-0 p-0 onlyMediaScreen" fluid={true}>
        {""}

        {props.displayLabel && offerLable()}

        {props.offerType === "SetPAY" || props.offerType === "SetPAYIn4" ? (
          <Card
            className="borderNoneoffer"
            style={{
              borderColor:
                props.prefferedOffer == "YES"
                  ? props.brandings.mppPrimaryColors
                  : "#f0f1f0",
            }}
          >
            <Card.Header className="borderNone">
              <Row className="textAlignInt">
                <Col xs="11" className="verticalCenter ifmediaScreen">
                  <>
                    <p role="heading" aria-level="3" className="mb-0 testClass marginLeft ">
                      <b>
                        {parse(props.offerLoyaltyPromoDisclosure || props.offerBannerTitle)}
                      </b>
                    </p>
                    <p className="mb-0 testClass marginLeft marginTop-5">
                      {parse(props.offerBannerSubTitle)}
                    </p>
                    <span className="ifTotalPayment mb-0 subTitleInfo marginLeft">
                      {parse(props.offerLoyaltyPromoDisclosure ? props.offerBannerTitle : "")}
                    </span>
                    <span className="ifTotalPayment mb-0 subTitleInfo marginLeft">
                      {offerRangeLanguage}
                    </span>
                    <span className="ifTotalPayment mb-0 subTitleInfo marginLeft">
                      {parse(props.ofpTitle)}
                    </span>
                    {props.limitedTimeOfferDateFormat && (
                      <span className="ifTotalPayment mb-0 subTitleInfo marginLeft">
                        {props.limitedTimeOfferDateFormat}
                      </span>
                    )}
                    {
                      <span className="ifTotalPayment mb-0 subTitleInfo marginLeft">
                        {props.offerBannerDisclaimer}
                      </span>
                    }
                  </>
                </Col>
                <Col xs="1" className="learmoreBtn onlyMedialearn">
                  <Accordion.Item
                    as={Card.Header}
                    eventKey={`${WPDAIndex}`}
                    style={{ display: "inline-grid" }}
                    onClick={() => {
                      setToggleBtn(!toggleBtn);
                    }}
                  >
                    {props.toggleProp === props.ofpTitle + props.index ? (
                      toggleBtn ? (
                        <button
                          id={`btn${WPDAIndex}`}
                          className="btn learBtn caret2 learnHow"
                          aria-expanded="false"
                          tabIndex="0"
                          onClick={(event) => {
                            analyticsChanges();
                            showOffers(WPDAIndex);
                            setActiveIndex(WPDAIndex);
                            if (
                              activeIndex !== "" ||
                              (isWPDAAtFirst && WPDAIndex == 0)
                            ) {
                              if (
                                document.getElementById(
                                  "removeshow" + activeIndex
                                ) &&
                                document.getElementById(
                                  "removeshow" + activeIndex
                                ).classList
                              ) {
                                document
                                  .getElementById("removeshow" + activeIndex)
                                  .classList.remove("show");
                              }
                            } else {
                              event.stopPropagation();
                              event.preventDefault();
                            }
                          }}
                          style={{ color: "black" }}
                        >
                          <img
                            id={`img${WPDAIndex}`}
                            src={learchHowIconDownimg}
                            alt="Learn How Down Icon"
                          />{" "}
                        </button>
                      ) : (
                        <button
                          id={`btn${WPDAIndex}`}
                          className="btn learBtn learnBtntoggle learnHow"
                          tabIndex="0"
                          onClick={(event) => {
                            analyticsChanges();
                            showOffers(WPDAIndex);
                            setActiveIndex(WPDAIndex);
                            if (
                              activeIndex !== "" ||
                              (isWPDAAtFirst && WPDAIndex == 0)
                            ) {
                              if (
                                document.getElementById(
                                  "removeshow" + activeIndex
                                ) &&
                                document.getElementById(
                                  "removeshow" + activeIndex
                                ).classList
                              ) {
                                document
                                  .getElementById("removeshow" + activeIndex)
                                  .classList.remove("show");
                              }
                            } else {
                              event.stopPropagation();
                              event.preventDefault();
                            }
                          }}
                          style={{ color: "black" }}
                        >
                          <img
                            id={`img${WPDAIndex}`}
                            src={learchHowIconDownimg}
                            alt="Learn How Down Icon"
                          />{" "}
                        </button>
                      )
                    ) : (
                      <button
                        id={`btn${WPDAIndex}`}
                        className="btn learBtn learnBtntoggle learnHow"
                        tabIndex="0"
                        onClick={(event) => {
                          analyticsChanges();
                          showOffers(WPDAIndex);
                          setActiveIndex(WPDAIndex);
                          if (
                            activeIndex !== "" ||
                            (isWPDAAtFirst && WPDAIndex == 0)
                          ) {
                            if (
                              document.getElementById(
                                "removeshow" + activeIndex
                              ) &&
                              document.getElementById(
                                "removeshow" + activeIndex
                              ).classList
                            ) {
                              document
                                .getElementById("removeshow" + activeIndex)
                                .classList.remove("show");
                            }
                          } else {
                            event.stopPropagation();
                            event.preventDefault();
                          }
                        }}
                        style={{ color: "black" }}
                      >
                        <img
                          id={`img${WPDAIndex}`}
                          src={learchHowIconDownimg}
                          alt="Learn How Down Icon"
                        />{" "}
                      </button>
                    )}
                    <span
                      id={`span${WPDAIndex}`}
                      style={{
                        fontSize: "9px",
                        textAlign: "center",
                        width: "27px",
                        color: "#000",
                        fontWeight: mppFromEmail ? "800" : "600",
                        lineHeight: "10px",
                      }}
                    >
                      {" "}
                      Learn How
                    </span>
                  </Accordion.Item>
                </Col>
              </Row>
            </Card.Header>

            <Accordion.Collapse
              eventKey={`${WPDAIndex}`}
              id={`removeshow${WPDAIndex}`}
            >
              <Card.Body
                id={props.ofpTitle + props.index}
                name={props.ofpTitle + props.index}
              >
                <div className="expansionDiv">
                  {/* <div tabIndex="0"> {ReactHtmlParser(props.monthlyPaymentDisclosure)} </div>
                <br /> */}
                  {isWPDAAtFirst &&
                    props.index === 0 &&
                    props.offerType === "WPDI" ? (
                    <>{!btnShow && <></>}</>
                  ) : (
                    <>
                      <div>
                        <div>
                          {" "}
                          {parse(props.monthlyPaymentDisclosureLanguage)}{" "}
                        </div>

                        <div>
                          {<br />}
                          {parse(props.offerDisclosure)}{" "}
                        </div>
                        <div>
                          {parse(props.offerDisclosureLanguage)}{" "}
                        </div>
                      </div>

                      <CustomToggle
                        tabIndex="0"
                        aria-labelledby="view less"
                        type="button"
                        className="testFocus"
                        eventKey={`${WPDAIndex}`}
                      >
                        <span
                          aria-labelledby="view less"
                          style={{ color: props.brandings.mppPrimaryColors }}
                        >
                          View Less
                        </span>
                      </CustomToggle>
                    </>
                  )}
                </div>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        ) : (
          ""
        )}
      </Container>
    );
  }

  const displaySetPayIn4 = () => {
    return (
      <Container className="ml-0 p-0 onlyMediaScreen" fluid={true}>
        {offerLable()}

        <Card
          className="borderNoneoffer"
          style={{
            borderColor:
              props.prefferedOffer == "YES"
                ? props.brandings.mppPrimaryColors
                : "#f0f1f0",
          }}
        >
          <Card.Header className="borderNone">
            <Row className="textAlignInt">
              <Col xs="11" className="verticalCenter ifmediaScreen ">
                <p role="heading" aria-level="3" className="mb-0 testClass marginLeft ">
                  <b> 
                    {parse(props.offerLoyaltyPromoDisclosure || props.offerBannerTitle)} 
                  </b>
                </p>
                <p className="mb-0 testClass marginLeft marginTop-5">
                  {parse(props.offerBannerSubTitle)}
                </p>
                <span className="ifTotalPayment mb-0 subTitleInfo marginLeft">
                  {parse(props.offerLoyaltyPromoDisclosure ? props.offerBannerTitle : "")}
                </span>
                <span className="ifTotalPayment mb-0 subTitleInfo marginLeft">
                  {parse(props.ofpTitle)}
                </span>
                {props.limitedTimeOfferDateFormat && (
                  <span className="ifTotalPayment mb-0 subTitleInfo marginLeft">
                    {props.limitedTimeOfferDateFormat}
                  </span>
                )}
                {
                  flowType !== "CHECKOUT" &&
                  <span className="ifTotalPayment mb-0 subTitleInfo marginLeft">
                    {props.offerBannerDisclaimer}
                  </span>
                }
              </Col>

              {!isSetPayIn4Alone && (<Col xs="1" className="learmoreBtn onlyMedialearn">
                <Accordion.Item
                  as={Card.Header}
                  eventKey={`${WPDAIndex}`}
                  style={{ display: "inline-grid" }}
                  onClick={() => {
                    analyticsChanges();
                    props.callback(props.ofpTitle + props.index);
                    setToggleBtn(!toggleBtn);
                    if (props.accordianIndex) {
                      setTimeout(function () {
                        var elem = document.getElementById(
                          "testActive" + (props.accordianIndex - 1)
                        );
                        if (elem != null) {
                          elem.scrollIntoView();
                        }
                      }, 300);
                    }
                  }}
                >
                  {props.toggleProp === props.ofpTitle + props.index ? (
                    toggleBtn ? (
                      <button
                        id={`btn${WPDAIndex}`}
                        className="btn learBtn caret2 learnHow"
                        aria-expanded="false"
                        tabIndex="0"
                        onClick={(event) => {
                          showOffers(WPDAIndex);
                          setActiveIndex(WPDAIndex);
                          if (
                            activeIndex !== "" ||
                            (isWPDAAtFirst && WPDAIndex == 0)
                          ) {
                            if (
                              document.getElementById(
                                "removeshow" + activeIndex
                              ) &&
                              document.getElementById(
                                "removeshow" + activeIndex
                              ).classList
                            ) {
                              document
                                .getElementById("removeshow" + activeIndex)
                                .classList.remove("show");
                            }
                          } else {
                            event.stopPropagation();
                            event.preventDefault();
                          }
                        }}
                        style={{ color: "black", marginLeft: "2px" }}
                      >
                        <img
                          id={`img${WPDAIndex}`}
                          src={learchHowIconDownimg}
                          alt="Learn How Down Icon"
                        />
                      </button>
                    ) : (
                      <button
                        id={`btn${WPDAIndex}`}
                        className="btn learBtn learnBtntoggle learnHow"
                        tabIndex="0"
                        style={{ color: "black" }}
                        onClick={(event) => {
                          showOffers(WPDAIndex);
                          setActiveIndex(WPDAIndex);
                          if (
                            activeIndex !== "" ||
                            (isWPDAAtFirst && WPDAIndex == 0)
                          ) {
                            if (
                              document.getElementById(
                                "removeshow" + activeIndex
                              ) &&
                              document.getElementById(
                                "removeshow" + activeIndex
                              ).classList
                            ) {
                              document
                                .getElementById("removeshow" + activeIndex)
                                .classList.remove("show");
                            }
                          } else {
                            event.stopPropagation();
                            event.preventDefault();
                          }
                        }}
                      >
                        <img
                          id={`img${WPDAIndex}`}
                          src={learchHowIconDownimg}
                          alt="Learn How Down Icon"
                        />{" "}
                      </button>
                    )
                  ) : (
                    <button
                      id={`btn${WPDAIndex}`}
                      className="btn learBtn learnBtntoggle learnHow"
                      tabIndex="0"
                      onClick={(event) => {
                        showOffers(WPDAIndex);
                        if (
                          activeIndex !== "" ||
                          (isWPDAAtFirst && WPDAIndex == 0)
                        ) {
                          if (
                            document.getElementById(
                              "removeshow" + activeIndex
                            ) &&
                            document.getElementById("removeshow" + activeIndex)
                              .classList
                          ) {
                            document
                              .getElementById("removeshow" + activeIndex)
                              .classList.remove("show");
                          }
                        } else {
                          event.stopPropagation();
                          event.preventDefault();
                        }
                      }}
                    >
                      <img
                        id={`img${WPDAIndex}`}
                        src={learchHowIconDownimg}
                        alt="Learn How Down Icon"
                      />{" "}
                    </button>
                  )}
                  <span
                    id={`span${WPDAIndex}`}
                    style={{
                      fontSize: "9px",
                      textAlign: "center",
                      width: "27px",
                      color: "#000",
                      fontWeight: mppFromEmail ? "800" : "600",
                      lineHeight: "10px",
                    }}
                  >
                    {" "}
                    Learn How
                  </span>
                </Accordion.Item>
              </Col>)}
            </Row>
          </Card.Header>
          {/* payn4 only Accordion changes */}
          {isSetPayIn4Alone && (<Accordion defaultActiveKey="0">
            <Accordion.Collapse eventKey="0">
              <Card.Body
                id={props.ofpTitle + props.index}
                name={props.ofpTitle + props.index}
              >
                <div
                  className={`expansionDiv${WPDAIndex}`}
                  id="expansionDivTest"
                >
                  {
                    <>
                      <div>
                        <div>
                          <div>
                            <p className="setPayIn4ExpansionText setPayIn4Font">
                              {parse(props.monthlyPaymentDisclosure)}
                            </p>
                          </div>
                          <br></br>
                          {flowType !== "CHECKOUT" && (
                            <>
                              <div style={{ display: "flex", paddingBottom: "14px" }} className="setPayIn4">
                                <div className="setPayIn4Icon">
                                  <img src={plShopBag} alt="" />
                                </div>
                                <div className="setPayIn4Content">
                                  <b className="setPayIn4Font">{parse(props.offerDisclosure)}</b>
                                  <br></br>
                                  {parse(props.offerDisclosureDisclaimer)}
                                </div>
                              </div>
                              <div className="setPayIn4Offer setPayIn4">
                                <div className="setPayIn4Icon">
                                  <img src={plShopCart} alt="" />
                                </div>
                                <div className="setPayIn4Content">
                                  <b className="setPayIn4Font">
                                    Choose
                                    <span>
                                      <img
                                        src={props.brandings.synchronySetPayIn4Image}
                                        alt="Pay Later"
                                        title="Pay Later"
                                        className="setpayin4-img"
                                      />
                                    </span>
                                    at checkout
                                  </b>
                                </div>
                              </div>
                            </>
                          )
                          }

                          <div className="setPayIn4">
                            <div className="setPayIn4Icon" style={{ paddingLeft: "2px" }}>
                              <img src={plPie} alt="" />
                            </div>
                            <div className="setPayIn4Content">
                              <b className="setPayIn4Font">
                                {parse(props.monthlyPaymentDisclosureLanguage)}
                              </b>{" "}
                              <br></br>
                              {props.monthlyPaymentDisclosureLanguageDisclaimer}
                            </div>
                          </div >
                          <hr className="hr1" />
                          <div className="col-12 text-center pdpPayN4NoteSec" style={{ paddingLeft: "5px", paddingRight: "5px" }}>
                            {flowType !== "CHECKOUT" ? parse(props.offerDisclosureLanguage) : parse(props.offerDisclosure)}
                          </div>
                        </div>
                      </div>
                    </>
                  }
                </div>
              </Card.Body>
            </Accordion.Collapse>
          </Accordion>)}
          {/* Accordion with multiple offers : this existing code itself*/}
          {!isSetPayIn4Alone && (<Accordion.Collapse
            eventKey={`${WPDAIndex}`}
            id={`removeshow${WPDAIndex}`}
          >
            <Card.Body
              id={props.ofpTitle + props.index}
              name={props.ofpTitle + props.index}
            >
              <div
                className={`expansionDiv${WPDAIndex}`}
                id="expansionDivTest"
              >
                {flowType === "CHECKOUT"
                  ? (
                    <>
                      <div>
                        <p className="setPayIn4ExpansionText setPayIn4Font">
                          {parse(props.monthlyPaymentDisclosure)}
                        </p>
                      </div>
                      <br></br>


                      <div className="setPayIn4">
                        <div className="setPayIn4Icon" style={{ paddingLeft: "2px" }}>
                          <img src={plPie} alt="" />
                        </div>
                        <div className="setPayIn4Content">
                          <b className="setPayIn4Font">
                            {parse(props.monthlyPaymentDisclosureLanguage)}
                          </b>{" "}
                          <br></br>
                          {props.monthlyPaymentDisclosureLanguageDisclaimer}
                        </div>
                      </div>
                      <hr className="hr1" />
                      <div className="col-12 text-center pdpPayN4NoteSec" style={{ paddingLeft: "5px", paddingRight: "5px" }}>
                        {parse(props.offerDisclosure)}
                      </div>
                      <CustomToggle
                        tabIndex="0"
                        aria-labelledby="view less"
                        type="button"
                        className="testFocus"
                        eventKey={`${WPDAIndex}`}
                      >
                        <span
                          aria-labelledby="view less"
                          style={{ color: props.brandings.mppPrimaryColors }}
                        >
                          View Less
                        </span>
                      </CustomToggle>
                    </>
                  ) : (
                    <>
                      <div>
                        <div>
                          <div>
                            <p className="setPayIn4ExpansionText setPayIn4Font">
                              {parse(props.monthlyPaymentDisclosure)}
                            </p>
                          </div>
                          <br></br>
                          <div style={{ display: "flex", paddingBottom: "14px" }} className="setPayIn4">
                            <div className="setPayIn4Icon">
                              <img src={plShopBag} alt="" />
                            </div>
                            <div className="setPayIn4Content">
                              <b className="setPayIn4Font">{parse(props.offerDisclosure)}</b>
                              <br></br>
                              {parse(props.offerDisclosureDisclaimer)}
                            </div>
                          </div>
                          <div className="setPayIn4Offer setPayIn4">
                            <div className="setPayIn4Icon">
                              <img src={plShopCart} alt="" />
                            </div>
                            <div className="setPayIn4Content">
                              <b className="setPayIn4Font">
                                Choose
                                <span>
                                  <img
                                    src={props.brandings.synchronySetPayIn4Image}
                                    alt="Pay Later"
                                    title="Pay Later"
                                    className="setpayin4-img"
                                  />
                                </span>
                                at checkout
                              </b>
                            </div>
                          </div>
                          <div className="setPayIn4">
                            <div className="setPayIn4Icon" style={{ paddingLeft: "2px" }}>
                              <img src={plPie} alt="" />
                            </div>
                            <div className="setPayIn4Content">
                              <b className="setPayIn4Font">
                                {parse(props.monthlyPaymentDisclosureLanguage)}
                              </b>{" "}
                              <br></br>
                              {props.monthlyPaymentDisclosureLanguageDisclaimer}
                            </div>
                          </div >
                          <hr className="hr1" />
                          <div className="text-center" style={{ paddingLeft: "5px", paddingRight: "5px" }}>
                            {parse(props.offerDisclosureLanguage)}
                          </div>
                        </div>
                      </div>

                      <CustomToggle
                        tabIndex="0"
                        type="button"
                        className="testFocus"
                        eventKey={`${WPDAIndex}`}
                      >
                        <span
                          aria-labelledby="view less"
                          style={{ color: props.brandings.mppPrimaryColors }}
                        >
                          View Less
                        </span>
                      </CustomToggle>
                    </>
                  )}
              </div>
            </Card.Body>
          </Accordion.Collapse>)}
        </Card >
        {flowType === "CHECKOUT" && (
          <Row>
            <Col xs="12">
              <div className="existingCard-holder payIn4-terms onlypayIn4Term">
                {parse(props.offerDisclosureLanguage)}
              </div>
              <div className="text-center"><Button
                className="btn btnPrimary modal-title checkoutFlowButtons syfClickEvent"
                data-type="body" 
                data-object="button"
								data-reason= "apply now"
                tabIndex="0"
                style={{
                  backgroundColor: props.brandings.mppPrimaryColors,
                  borderColor: props.brandings.mppPrimaryColors,
                }}
                onClick={ openSetPayIn4 }
              >
                APPLY NOW
              </Button>
              </div>
            </Col>
          </Row>
        )}
      </Container >
    );
  };

  function getDeviceType() {
    const ua = navigator.userAgent;
    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
      return "tablet";
    }
    if (
      /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
        ua
      )
    ) {
      return "mobile";
    }
    return "desktop";
  }

  function analyticsChanges() {
    const pageInfo = window._syf_?._mppOffer_?._SFDDL?.pageInfo || {};
    // Append " | loyalty <loyaltyPromoDisclosure>" to OfferName only when a non-null / non-blank
    // loyaltyPromoDisclosure value is available for this offer.
    const hasLoyaltyDisclosure =
      props.offerLoyaltyPromoDisclosure != null &&
      String(props.offerLoyaltyPromoDisclosure).trim() !== "";
    const offerNameWithLoyalty = hasLoyaltyDisclosure
      ? `${props.ofpTitle} | loyalty ${props.offerLoyaltyPromoDisclosure}`
      : props.ofpTitle;

    window._syf_._mppOffer_._SFDDL.pageInfo = {
      ...pageInfo,
      Country_Language: "US|ENG",
      SiteIdentifier: "digitalpos",
      Device: getDeviceType(),
      PNL: "PS",
      CustomerType: "consumer",
      ClientName: props.merchantName,
      MerchantID: props.merchantNumber,
      PageKind: "merchant",
      PageFunction: "offers_mpp",
      PageName: "offer_details_page",
      OfferCount: "",
      TargetName: "",
      TokenId: props.syfToken,
      Message: "MPP Page Learn How",
      OfferType: props.offerType,
      OfferName: offerNameWithLoyalty,
      tenure: props.durationInMonth,
      PaymentType: "",
      SyfPartnerID: props.partnerId,
      orgPlatForm
    };

    window._syf_._mppOffer_._SFDDL.click = {
      action: "syfClickEvent",
      className: "syfClickEvent",
      "data-object": "button",
      "data-reason": "learnhow",
      "data-type": "body",
    };

    window._syf_._mppOffer_._SFDDL.formAction = {
      appType: "offers_mpp",
      product: "MPP",
      action: "offer_details_page",
    };
    var event = document.createEvent("Event");
    event = new CustomEvent("syfClickEvent");
    event.initEvent("syfClickEvent");
    dispatchEvent(event);
  }

  const getOfferRelatedInfo = (offerType) => {
    switch (offerType) {
      case "SetPAY":
        return firstRow2();

      case "SetPAYIn4":
        return displaySetPayIn4();

      default:
        return firstRow();
    }
  };

  return (
    <>
      <div>{getOfferRelatedInfo(props.offerType)}</div>
    </>
  );
};

export default MppModalInfo;
